import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import { computed, toRefs } from 'vue';

interface Props {
  name?: string;
  color?: string;
  library?: string;
  size?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: { default: 'circle' },
    color: { default: 'var(--text-color-secondary)' },
    library: { default: 'material-icons' },
    size: { default: 'md-18' }
  },
  setup(__props: any) {

const props = __props;

const { name, library, size } = toRefs(props);

const classStyles: string = computed(() => `${library.value} ${size.value} select-none`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(classStyles.value),
    textContent: _toDisplayString(_unref(name))
  }, null, 10, _hoisted_1))
}
}

})